package com.appcreator.compose.actions

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.actions.ReviewPromptAction
import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.EnvStore

@Composable
actual fun ReviewPromptPerformerDeferred(action: ReviewPromptAction): Performer.Deferred {
    return object : Performer.Deferred {
        override suspend fun perform(envStore: EnvStore) {
            println("This platform does not support review prompt")
        }
    }
}